import React, { Fragment, useEffect, useState } from 'react'

import { BiStore } from 'react-icons/bi';
import { FaShippingFast } from 'react-icons/fa';
import { FiArrowLeft, FiPackage, FiTruck, FiMapPin, FiCheck } from 'react-icons/fi';

import { useHistory } from "react-router-dom";
import { Card, Typography, Stack, Box, Container, IconButton, Button, Radio, Grid, TextField, Avatar, Divider } from '@mui/material';

import { format } from 'date-fns';
import { useDispatch, useSelector } from "react-redux";
import Actions from "../../constants/Actions";


import { getCepUser, dataUser, getDataUsuario } from "../../services/auth";
// actions
import buscaCep from "../../actions/buscaCep";
import cotarCorreios from '../../actions/global/cotarCorreios'

//components
import Stepper from "../../components/Stepper";
import Skeleton from '@material-ui/lab/Skeleton';
import { getValorSubTotal, pesoCalculado, maiorLarguraItems, maiorComprimentoItems, alturaCalculado } from '../../utils/functions';

// actions
import buscarFilialPorCodigoFilial from '../../actions/cadastro/buscar-filial-por-codigo-filial';
import actionConfigVendaFacil from '../../actions/config/actionConfigVendaFacil';
import actionBuscarFiliaisCidades from '../../actions/config/actionBuscarFiliaisCidades';


const ShippingPage = ({ proximoPasso }) => {

  const [tipoEntrega, setTipoEntrega] = useState('');
  const [transportadora, setTransportadora] = useState(null);

  const [cepProduto, setCepProduto] = useState('');

  const [fretePatrus, setFretePatrus] = useState('19.90');
  const [freteCorreios, setFreteCorreios] = useState("");
  const [freteCorreiosSedex, setFreteCorreiosSedex] = useState("");
  const [mostrarFretesEntregas, setMostrarFretesEntregas] = useState(false);
  const [isLoadingFrete, setIsLoadingFrete] = useState(false);
  const [cepDigitado, setCepDigitado] = useState('');
  const [diasEntrega, setDiasEntrega] = useState('');
  const [valorFreteRetirada, setValorFreteRetirada] = useState(0);
  const [config, setConfig] = useState(null);
  const [entregaBloqueada, setEntregaBloqueada] = useState(false);
  const [retiradaGratis, setRetiradaGratis] = useState(false);
  // cep
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');

  const cepOrigemProduto = useSelector(state => state.cepOrigemProduto);
  const cartItems = useSelector(state => state.cartItems);
  const valorFrete = useSelector(state => state.valorFrete);
  const filialUsuario = getDataUsuario().filial


  const [subtotal, setSubtotal] = React.useState(0)
  const date = new Date();

  const dispatch = useDispatch();
  const history = useHistory();

  async function buscarConfig() {
    try {
      const res = await actionConfigVendaFacil();
      setConfig(res.data.data.vendafacil);
      return res.data.data.vendafacil;

    } catch (err) {
      console.log('Erro ao buscar config', err)
    }
  }


  async function validaEntregaFranquia() {
    const res_filiais_cidades = await actionBuscarFiliaisCidades(filialUsuario);
    console.log('res_filiais_cidades', res_filiais_cidades.data.data)
    if (!res_filiais_cidades.data.data) return;
    console.log('apos res_filiais_cidades', res_filiais_cidades)
    const res_config = await buscarConfig();
    const filiaisCidades = res_filiais_cidades.data.data.filiais;
    let isFilialImpedida = res_config.filais_impedidas_entrega.includes(filialUsuario) // verifica sa loja do usuario esta impedida de fazer envios na cidade

    if (!isFilialImpedida) return;

    if (!cartItems) return;
    if (cartItems.length === 0) return;
    if (!res_config) return;
    let filiaisCarrinho = cartItems.map(i => i.filial);
    if (filiaisCidades.some(valor => filiaisCarrinho.includes(valor))) {
      console.log('filiaisCarrinho.includes(filiaisCidades)', filiaisCarrinho.includes(filiaisCidades))
      setEntregaBloqueada(true);
      setRetiradaGratis(true)
      setValorFreteRetirada(0)
    } else {
      console.log('erro', filiaisCarrinho, filiaisCidades)
    }
  }




  useEffect(() => {
    if (cartItems.length == 0) {
      alert('Seu Carrinho está vazio, você será redirecionado para a página inicial')
      history.push('/');
    }
    validaEntregaFranquia()

    buscarFilialPorCodigoFilial(cepOrigemProduto).then(res => {
      setCepProduto(res.data.cep)
    })

  }, []);








  const handleBuscaCep = async (zipCode) => {
    try {
      const address = await buscaCep(zipCode)
      if (address.erro) {
        alert('CEP ano encontrado!')
      } else {
        setCidade(address.localidade);
        setEstado(address.uf);
        return address;
      }
    } catch (address) {
      alert('CEP ano encontrado!');
    }
  }



  const handleBuscarFreteEntrega = async (e) => {
    e.preventDefault();
    setIsLoadingFrete(true);
    setMostrarFretesEntregas(true)

    const response = await handleBuscaCep(cepDigitado);


    cotarCorreios({
      altura: alturaCalculado(cartItems),
      comprimento: maiorComprimentoItems(cartItems),
      largura: maiorLarguraItems(cartItems),
      peso: pesoCalculado(cartItems),
      cepOrigem: cepProduto,
      cepDestino: cepDigitado
    }
    ).then(res => {
      const freteInt = parseInt(res.data.result.sedex.Valor);
      if (getValorSubTotal(cartItems) > 199) {
        if (response.uf === 'MG') {

          setFreteCorreios(0);
          setFreteCorreiosSedex(0);
          setIsLoadingFrete(false);




        } else {
          if (res.data.result.sedex.Valor < 1) {
            setFreteCorreios(20);
            setFreteCorreiosSedex(20);
            setIsLoadingFrete(false);
          } else {

            setFreteCorreios(res.data.result.sedex.Valor.replace(',', '.'));
            setFreteCorreiosSedex(res.data.result.pac.Valor.replace(',', '.'));
            setIsLoadingFrete(false);
          }



        }
      } else {

        if (freteInt === 0) {
          setFreteCorreios(20);
          setFreteCorreiosSedex(20);
          setIsLoadingFrete(false);
        } else {

          setFreteCorreios(res.data.result.sedex.Valor.replace(',', '.'));
          setFreteCorreiosSedex(res.data.result.pac.Valor.replace(',', '.'));
          setIsLoadingFrete(false);
        }

      }
    }).catch(e => {
      setFreteCorreios(20);
      setFreteCorreiosSedex(20);
      setIsLoadingFrete(false);
      alert('Erro ao calcular o frete, entre em contato com o suporte para averiguar o erro ou tente novamente.')
    })

  }

  const handleRetirada = () => {
    if (retiradaGratis) {
      setValorFreteRetirada(0);
      dispatch({ type: Actions.TIPO_ENTREGA, tipoEntrega: "Retirada" });
      setTipoEntrega('Retirada');
      setTransportadora('')
      return;
    }
    if (getCepUser() >= 35500000 & getCepUser() <= 35505000) {
      setValorFreteRetirada(0)
    } else {
      if (getValorSubTotal(cartItems) < 149) {
        setValorFreteRetirada(20)
      } else {
        setValorFreteRetirada(0)
      }
    }
    dispatch({ type: Actions.TIPO_ENTREGA, tipoEntrega: "Retirada" });
    setTipoEntrega('Retirada');
    setTransportadora('')
  }

  const handleEntrega = () => {
    setTipoEntrega('Entrega');
    dispatch({ type: Actions.TIPO_ENTREGA, tipoEntrega: "Entrega" });
    setTransportadora('')
  }





  const handleEscolhePac = () => {
    setTransportadora('Pac');
    dispatch({ type: Actions.valorFrete, valorFrete: Number.parseFloat(freteCorreios) });
    dispatch({ type: Actions.SHIPPING_ID, shippingId: "61532d990d253dd8a450bcde" });


  }


  const handleEscolhePatrus = () => {
    setTransportadora('Patrus');
    dispatch({ type: Actions.SHIPPING_ID, shippingId: "61560313eaf72f4fe7f5ee25" });
    dispatch({ type: Actions.valorFrete, valorFrete: fretePatrus.ValorFrete });

  }


  const handleEscolhePropria = () => {

    if (retiradaGratis) {
      setValorFreteRetirada(0);
      dispatch({ type: Actions.TIPO_ENTREGA, tipoEntrega: "Retirada" });
      setTipoEntrega('Retirada');
      setTransportadora('Total');
      dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
      dispatch({ type: Actions.SHIPPING_ID, shippingId: "61560325eaf72f4fe7f5ee27" });
      return;
    }
    setTransportadora('Total');
    dispatch({ type: Actions.SHIPPING_ID, shippingId: "61560325eaf72f4fe7f5ee27" });
    dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })

    if (tipoEntrega === "Retirada") {
      if (getCepUser() >= 35500000 & getCepUser() <= 35505000) {
        dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
      } else {
        if (getValorSubTotal(cartItems) < 149) {
          dispatch({ type: Actions.valorFrete, valorFrete: 20.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }
      }
    }


    if (tipoEntrega === 'Entrega') {
      if (cepDigitado >= 35500000 & cepDigitado <= 35505000) {
        if (getValorSubTotal(cartItems) < 199) {
          dispatch({ type: Actions.valorFrete, valorFrete: 14.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }

      } else {
        if (getValorSubTotal(cartItems) < 199) {
          dispatch({ type: Actions.valorFrete, valorFrete: 20.00 })
        } else {
          dispatch({ type: Actions.valorFrete, valorFrete: 0.00 })
        }
      }

    }

  }

  const validaEntregaPropria = () => {
    if (cepDigitado >= 35500000 & cepDigitado <= 35505000) {
      if (getValorSubTotal(cartItems) < 199) {
        return 14.00;
      } else {
        return 0.00
      }

    } else {
      if (getValorSubTotal(cartItems) < 199) {
        return 18.00;
      } else {
        return 0.00
      }
    }
  }


  const voltarPdv = () => {
    history.push('pdv');
    dispatch({ type: Actions.valorFrete, valorFrete: 0 });
  }

  const CardTransportadora = ({ click, img, tipoEntrega, titulo, valorFrete, dataMaxima, valorItens }) => {

    function valorRestante() {
      if (valorItens < 149) {
        let total = 150 - valorItens;
        return total.toFixed(2);
      }
    }

    return (
      <Box
        sx={{
          p: { xs: 2.5, md: 3 },
          borderRadius: 2.5,
          border: '1px solid',
          borderColor: transportadora === 'Total' ? '#1a1a2e' : 'grey.200',
          boxShadow: transportadora === 'Total' ? '0 0 0 1px #1a1a2e' : '0 1px 3px rgba(0,0,0,0.06)',
          bgcolor: '#fff',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            borderColor: '#1a1a2e',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Radio
            checked={transportadora === 'Total'}
            value={transportadora}
            name="radio-button-demo"
            sx={{
              color: 'grey.400',
              '&.Mui-checked': { color: '#1a1a2e' },
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontWeight: 600, color: '#1a1a2e', fontSize: '0.95rem' }}>
              {titulo}
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: '1.25rem', color: '#1a1a2e', mt: 0.5 }}>
              R$ {valorFrete}
            </Typography>
            {valorFreteRetirada > 0 && tipoEntrega === 'retirada' && (
              <Typography variant="caption" sx={{ color: 'grey.600', mt: 0.5, display: 'block' }}>
                Faltam <strong>R${valorRestante(valorItens)}</strong> para o frete ser gratis
              </Typography>
            )}
          </Box>
        </Stack>
      </Box>
    )
  }

  const CardTransportadoraEntrega = ({ click, img, tipoEntrega, titulo, valorFrete, dataMaxima }) => {
    return (
      <Box sx={{ py: 1 }}>
        <Typography sx={{ fontWeight: 600, color: '#1a1a2e', fontSize: '0.95rem' }}>
          {titulo}
        </Typography>
        <Typography sx={{ fontWeight: 700, fontSize: '1.25rem', color: '#1a1a2e', mt: 0.5 }}>
          R$ {valorFrete}
        </Typography>
        <Typography sx={{ color: 'grey.600', fontSize: '0.85rem', mt: 0.5 }}>
          {titulo === 'Total Express' ? (
            <>Chega ate <strong>2 dias uteis apos o pagamento</strong></>
          ) : (
            <>Chega ate <strong>{dataMaxima ? format(new Date(dataMaxima), 'dd/MM') : dataMaxima}</strong></>
          )}
        </Typography>
      </Box>
    )
  }


  return (
    <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: '#f5f5f5' }}>

      {/* Header */}
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5' }}>
        <Box sx={{ maxWidth: '98%', mx: 'auto', py: 1.5 }}>
          <Stack justifyContent="space-between" direction="row" alignItems="center">
            <IconButton onClick={voltarPdv} sx={{ color: '#1a1a2e' }}>
              <FiArrowLeft size={24} />
            </IconButton>
            <Stepper valorStep={2} />
          </Stack>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>

        <Stack spacing={3}>

          {tipoEntrega === 'Entrega' && (
            <>
              {/* CEP Search Card */}
              <Box
                sx={{
                  p: { xs: 2.5, md: 3 },
                  borderRadius: 2.5,
                  border: '1px solid',
                  borderColor: 'grey.200',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                  bgcolor: '#fff',
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2.5 }}>
                  <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
                    <FiMapPin size={18} />
                  </Avatar>
                  <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#1a1a2e' }}>
                    Calcular Frete para Entrega
                  </Typography>
                </Stack>

                <Box component="form" onSubmit={handleBuscarFreteEntrega} noValidate>
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="flex-start">
                    <TextField
                      type="text"
                      value={cepDigitado}
                      id="zip"
                      label="CEP Destino"
                      placeholder="00000-000"
                      onChange={e => setCepDigitado(e.target.value)}
                      required
                      variant="outlined"
                      size="small"
                      sx={{
                        flex: 1,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 1.5,
                          '&.Mui-focused fieldset': {
                            borderColor: '#1a1a2e',
                          },
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: '#1a1a2e',
                        },
                      }}
                    />
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        bgcolor: '#1a1a2e',
                        '&:hover': { bgcolor: '#16213e' },
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: 1.5,
                        px: 4,
                        py: 1,
                      }}
                    >
                      Buscar
                    </Button>
                  </Stack>
                </Box>
              </Box>

              {/* Shipping Options */}
              {mostrarFretesEntregas && (
                <Box
                  sx={{
                    p: { xs: 2.5, md: 3 },
                    borderRadius: 2.5,
                    border: '1px solid',
                    borderColor: 'grey.200',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                    bgcolor: '#fff',
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2.5 }}>
                    <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
                      <FiTruck size={18} />
                    </Avatar>
                    <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#1a1a2e' }}>
                      Opcoes de Entrega
                    </Typography>
                  </Stack>

                  <Grid container spacing={2}>
                    {cidade !== "Divinópolis" && (
                      <>
                        {isLoadingFrete === false ? (
                          <Grid item xl={3} md={4} lg={3} xs={12}>
                            <Box
                              onClick={handleEscolhePac}
                              sx={{
                                p: { xs: 2.5, md: 3 },
                                borderRadius: 2.5,
                                border: '1px solid',
                                borderColor: transportadora === 'Pac' ? '#1a1a2e' : 'grey.200',
                                boxShadow: transportadora === 'Pac' ? '0 0 0 1px #1a1a2e' : '0 1px 3px rgba(0,0,0,0.06)',
                                bgcolor: '#fff',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  borderColor: '#1a1a2e',
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                },
                              }}
                            >
                              <CardTransportadoraEntrega
                                click={handleEscolhePac}
                                img={'https://katuxa.sfo3.digitaloceanspaces.com/logos/correios.png'}
                                tipoEntrega={'correios'}
                                valorFrete={freteCorreios}
                                dataMaxima={(new Date()).setDate(date.getDate() + 8)}
                                titulo={"PAC"}
                              />
                            </Box>
                          </Grid>
                        ) : (
                          <Grid item xl={3} md={4} lg={3} xs={12}>
                            <Box
                              sx={{
                                p: { xs: 2.5, md: 3 },
                                borderRadius: 2.5,
                                border: '1px solid',
                                borderColor: 'grey.200',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                                bgcolor: '#fff',
                              }}
                            >
                              <Skeleton variant="circle" width={40} height={40} />
                              <Skeleton variant="text" width={200} height={100} />
                              <Skeleton variant="text" width={200} height={30} />
                              <Skeleton variant="text" width={200} height={30} />
                            </Box>
                          </Grid>
                        )}
                      </>
                    )}

                    {cidade === "Divinópolis" && (
                      <Grid item xl={3} md={4} lg={3} xs={12}>
                        <Box
                          onClick={handleEscolhePropria}
                          sx={{
                            p: { xs: 2.5, md: 3 },
                            borderRadius: 2.5,
                            border: '1px solid',
                            borderColor: transportadora === 'Total' ? '#1a1a2e' : 'grey.200',
                            boxShadow: transportadora === 'Total' ? '0 0 0 1px #1a1a2e' : '0 1px 3px rgba(0,0,0,0.06)',
                            bgcolor: '#fff',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              borderColor: '#1a1a2e',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            },
                          }}
                        >
                          <CardTransportadoraEntrega
                            click={() => handleEscolhePatrus()}
                            img={'https://katuxa.sfo3.digitaloceanspaces.com/logos/katuxa.png'}
                            tipoEntrega={'katuxa'}
                            valorFrete={validaEntregaPropria()}
                            dataMaxima={date.setDate(date.getDate() + 2)}
                            titulo={"Entrega Propria"}
                          />
                        </Box>
                      </Grid>
                    )}
                  </Grid>

                  {transportadora && (
                    <Box sx={{ mt: 3 }}>
                      <Button
                        onClick={proximoPasso}
                        variant="contained"
                        fullWidth
                        sx={{
                          bgcolor: '#1a1a2e',
                          '&:hover': { bgcolor: '#16213e' },
                          textTransform: 'none',
                          fontWeight: 600,
                          borderRadius: 1.5,
                          py: 1.5,
                          fontSize: '1rem',
                        }}
                      >
                        Continuar
                      </Button>
                    </Box>
                  )}
                </Box>
              )}
            </>
          )}

          {tipoEntrega === 'Retirada' && (
            <Box
              sx={{
                p: { xs: 2.5, md: 3 },
                borderRadius: 2.5,
                border: '1px solid',
                borderColor: 'grey.200',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                bgcolor: '#fff',
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2.5 }}>
                <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
                  <FiPackage size={18} />
                </Avatar>
                <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#1a1a2e' }}>
                  Retirada
                </Typography>
              </Stack>

              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <Box onClick={handleEscolhePropria}>
                    <CardTransportadora
                      click={() => handleEscolhePropria()}
                      img={'https://katuxa.sfo3.digitaloceanspaces.com/logos/katuxa.png'}
                      tipoEntrega={'retirada'}
                      valorFrete={valorFreteRetirada}
                      dataMaxima={(new Date()).setDate(date.getDate() + 8)}
                      titulo={"Entrega Katuxa"}
                      valorItens={getValorSubTotal(cartItems)}
                    />
                  </Box>
                </Grid>
              </Grid>

              {transportadora && (
                <Box sx={{ mt: 3 }}>
                  <Grid container>
                    <Grid item md={6} xs={12}>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={proximoPasso}
                        sx={{
                          bgcolor: '#1a1a2e',
                          '&:hover': { bgcolor: '#16213e' },
                          textTransform: 'none',
                          fontWeight: 600,
                          borderRadius: 1.5,
                          py: 1.5,
                          fontSize: '1rem',
                        }}
                      >
                        Continuar
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Box>
          )}

        </Stack>
      </Box>
    </Box>
  )
}

export default ShippingPage;
